import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type BillingState = {
  dataStatistics: BillingStatisticsType;
  pagination: PaginationAPI;
  totalElements?: number;
  dataBilling: BillingType[];
};

export const billingInitialState: BillingState = {
  dataStatistics: {
    dateFromUtc: '',
    dateToUtc: '',
    totalInvoices: 0,
    totalAmount: 0,
    currency: '',
    paidCount: 0,
    paidAmount: 0,
    pendingCount: 0,
    pendingAmount: 0,
    failedCount: 0,
    failedAmount: 0,
    refundedCount: 0,
    refundedAmount: 0,
    averageInvoiceAmount: 0,
  },
  pagination: {
    pageNumber: Pagination.pageNumber,
    totalPages: 0,
    totalElements: 0,
    pageSize: Pagination.pageSize,
  },
  dataBilling: [],
};

export const slice = createSlice({
  name: 'billing',
  initialState: billingInitialState,
  reducers: {
    setListBillingStatisticsAction(
      state,
      { payload }: PayloadAction<{ dataStatistics: BillingStatisticsType }>,
    ) {
      state.dataStatistics = payload.dataStatistics;
    },

    setListBillingAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: BillingType[];
        pagination?: PaginationAPI;
        totalElements?: number;
      }>,
    ) {
      state.dataBilling = payload.data;
      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },
  },
});

export const { setListBillingStatisticsAction, setListBillingAction } = slice.actions;

export default slice.reducer;
